import { render, staticRenderFns } from "./BFlowStartProps.vue?vue&type=template&id=8cf20a70&scoped=true"
import script from "./BFlowStartProps.vue?vue&type=script&lang=js"
export * from "./BFlowStartProps.vue?vue&type=script&lang=js"
import style0 from "./BFlowStartProps.vue?vue&type=style&index=0&id=8cf20a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf20a70",
  null
  
)

export default component.exports